module.exports = __webpack_public_path__ + "static/ic_withdrawal_fail.742d8e6a.png";